import React, { useState,useEffect } from "react";
import { 
   trackGANativeApp, 
    updateNativeAppQueryParams_LocalStorage 
} from "../../constants/AppMethod";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../constants/Routes";
import { NativeAPP_GAEvents } from "../../constants/AppConstants";
import BenefitOfSuppliesMain from "./Shared/BenefitOfSuppliesMain";

export const BOSPageContext = React.createContext({});

const BenefitOfSuppliesWrapper = () => {
    const location = useLocation();
    const {pathname} = location;
    const [modalState, setModalState] = useState(false);

    const toggleModal  = () => {
        setModalState(!modalState);
    }
    const handleModalState = (state) => {
        setModalState(state)
    }
    const handleGetStarted = (skipValue, redirectPath = null) => {
        setModalState(false);
        updateNativeAppQueryParams_LocalStorage({app_redirect_URL: redirectPath}, `&web_selection=${skipValue}&selection=${skipValue}`);
        window.location.href = (redirectPath) ? redirectPath : nativeAppRoutePaths.LOGIN_PAGE_URL;
    }

    const OLD_VERSION_ROUTES = new Set([
        nativeAppRoutePaths.OLD_VERSION.DESKTOP_APP_BANNER,
        nativeAppRoutePaths.OLD_VERSION.BMC_BANNER,
    ]);

    const SINGLE_PAGE_SERVICE_ROUTES = new Set([
        nativeAppRoutePaths.BPLUS.BENEFIT_PAGE,
        nativeAppRoutePaths.ECOPRO.BENEFIT_PAGE,
    ]);

    const isOldVersion    = OLD_VERSION_ROUTES.has(pathname);
    const isEcoProOnly    = pathname === nativeAppRoutePaths.ECOPRO.BENEFIT_PAGE;
    const isBplusOnly     = pathname === nativeAppRoutePaths.BPLUS.BENEFIT_PAGE;
    const isDesktopAppOld = pathname === nativeAppRoutePaths.OLD_VERSION.DESKTOP_APP_BANNER;
    const isBMCAppOld     = pathname === nativeAppRoutePaths.OLD_VERSION.BMC_BANNER;

    const payload = {
        is_single_page_service: SINGLE_PAGE_SERVICE_ROUTES.has(pathname),
    };
    updateNativeAppQueryParams_LocalStorage(payload);
    
    const getGAEventName = () => {
        if (isOldVersion)   return NativeAPP_GAEvents.BENEFIT_OF_SUPPLIES_PAGE_OLD;
        if (isEcoProOnly)   return NativeAPP_GAEvents.BENEFIT_OF_SUPPLIES_PAGE_ECOPRO;
        if (isBplusOnly)    return NativeAPP_GAEvents.BENEFIT_OF_SUPPLIES_PAGE_BPLUS;
        return NativeAPP_GAEvents.BENEFIT_OF_SUPPLIES_PAGE;
    };
    
    useEffect(() => {
        const eventName = getGAEventName();
        trackGANativeApp(eventName);
        // eslint-disable-next-line
    }, []);

    const BOSPageDetails = {
        modalState: modalState,
        toggleModal: toggleModal,
        handleModalState: handleModalState,
        handleGetStarted: handleGetStarted,
        isEcoProOnly: isEcoProOnly,
        isBplusOnly: isBplusOnly, 
        isOldVersion: isOldVersion,
        isDesktopAppOld: isDesktopAppOld,
        isBMCAppOld: isBMCAppOld
    }

    return (
        <BOSPageContext.Provider value={BOSPageDetails}>
            <BenefitOfSuppliesMain />
        </BOSPageContext.Provider>
    )
}

export default BenefitOfSuppliesWrapper;